<p-dialog
  *ngIf="showJobDetailsDialog"
  [visible]="showJobDetailsDialog"
  (visibleChange)="onFlag('showJobDetailsDialog', $event)"
  [blockScroll]="true"
  [dismissableMask]="true"
  [draggable]="false"
  [modal]="true"
  [style]="{
    minWidth: '320px',
    maxWidth: '840px',
    width: '100%',
    padding: '0'
  }"
  class="dialog job-detail-dialog"
  appendTo="body"
  styleClass="job-detail-dialog">
  <div class="dialog-title">Position Details</div>

  <div class="job-detail-body mt-20">
    <div class="grid align-items-baseline no-margins light-text">
      <div
        [ngStyle]="{
          width: !isMobile ? '27%' : '30%',
          padding: '0.5em'
        }"
        class="text-right">
        Position Title
      </div>

      <div
        [ngStyle]="{
          width: !isMobile ? '72%' : '70%',
          padding: '0.5em'
        }"
        [pTooltip]="
          currentPitchCard?.positions[0]?.name
            ? currentPitchCard.positions[0].name
            : ''
        "
        [tooltipDisabled]="
          !currentPitchCard?.positions[0]?.name ||
          currentPitchCard?.positions[0]?.name.length < 30
        "
        [tooltipPosition]="'top'"
        class="col-9 normal-text large font-semibold text-ellipsis">
        {{ currentPitchCard?.positions[0]?.name || '' }}
      </div>
    </div>

    <div class="grid no-margins light-text">
      <div
        [ngStyle]="{
          width: !isMobile ? '27%' : '30%',
          padding: '0.5em'
        }"
        class="text-right">
        Compensation
      </div>

      <div
        [ngStyle]="{
          width: !isMobile ? '72%' : '70%',
          padding: '0.5em',
          overflowWrap: 'anywhere'
        }"
        class="normal-text">
        {{ compensationDescription || '' }}
      </div>
    </div>

    <div
      *ngIf="currentPitchCard?.benefits?.length"
      class="job-compensation grid justify-content-start justify-content-between mt-10">
      <div
        *ngFor="let benefit of benefits"
        class="job-compensation-badge bg-darkgray color-white mb-2 text-center text-ellipsis">
        {{ benefit ? (benefit.name | splitCamelCase) : '' }}
      </div>
    </div>

    <div class="grid no-margins light-text">
      <div
        [ngStyle]="{
          width: !isMobile ? '27%' : '30%',
          padding: '0.5em'
        }"
        class="text-right">
        Type
      </div>

      <div
        *ngIf="workTypes?.length"
        [ngStyle]="{
          width: !isMobile ? '72%' : '70%',
          padding: '0.5em'
        }"
        class="normal-text">
        <span>
          <span>{{ workTypesList || 'Full-Time' }}</span>
        </span>
      </div>

      <div
        *ngIf="!workTypes?.length"
        [ngStyle]="{
          width: !isMobile ? '72%' : '70%',
          padding: '0.5em'
        }"
        class="normal-text">
        <span>Full-Time</span>
      </div>
    </div>

    <div class="grid no-margins light-text">
      <div
        [ngStyle]="{
          width: !isMobile ? '27%' : '30%',
          padding: '0.5em'
        }"
        class="text-right">
        Location
      </div>

      <div
        *ngIf="!currentPitchCard?.isRemote"
        [ngStyle]="{
          width: !isMobile ? '72%' : '70%',
          padding: '0.5em'
        }"
        class="normal-text">
        {{ locationAddress || 'txt_default_job_location' | translate }}
      </div>

      <div
        *ngIf="currentPitchCard?.isRemote"
        [ngStyle]="{
          width: !isMobile ? '72%' : '70%',
          padding: '0.5em'
        }"
        class="normal-text"
        translate>
        txt_position_remote
      </div>
    </div>

    <div *ngIf="currentPitchCard?.positionRequirements" class="light-text">
      <div
        [ngStyle]="{
          width: !isMobile ? '27%' : '30%',
          padding: '0.5em'
        }"
        class="text-right mb-1">
        Requirements
      </div>

      <div class="textarea-template">
        <div [id]="'e_requirements_' + uniqueId" class="editor-preview"></div>
      </div>
    </div>
  </div>

  <div class="dialog-title mt-20 mb-1">Company Information</div>

  <div class="job-detail-body">
    <div
      [ngClass]="{
        'justify-content-end': !currentPitchCard.industries?.length,
        'justify-content-between': currentPitchCard.industries?.length
      }"
      class="grid no-margins light-text">
      <div
        *ngIf="currentPitchCard.industries?.length"
        class="industry-tags col-6 text-right">
        <div
          *ngFor="let industry of currentPitchCard.industries"
          class="industry-tag text-left">
          <span *ngIf="industry">{{
            industry?.name ? (industry.name | titlecase) : ''
          }}</span>
        </div>
      </div>

      <div class="grid justify-content-end col-6 no-padding no-margins">
        <div
          *ngIf="currentPitchCard?.websiteLink"
          class="logo-social-link web pointer">
          <a
            [href]="validateLink(currentPitchCard?.websiteLink)"
            pTooltip="Website"
            rel="noopener noreferrer"
            target="_blank"
            tooltipPosition="top">
            <img
              alt="website"
              src="/assets/images/pitch-card-svg/resume/web-icon.svg" />
          </a>
        </div>
        <div
          *ngIf="currentPitchCard?.facebookLink"
          class="logo-social-link pointer">
          <a
            [href]="validateLink(currentPitchCard?.facebookLink)"
            pTooltip="Facebook"
            rel="noopener noreferrer"
            target="_blank"
            tooltipPosition="top">
            <img
              alt="facebook"
              src="/assets/images/pitch-card-svg/facebook-icon.svg" />
          </a>
        </div>
        <div
          *ngIf="currentPitchCard?.instagramLink"
          class="logo-social-link pointer">
          <a
            [href]="validateLink(currentPitchCard?.instagramLink)"
            pTooltip="Instagram"
            rel="noopener noreferrer"
            target="_blank"
            tooltipPosition="top">
            <img
              alt="instagram"
              src="/assets/images/pitch-card-svg/instagram-icon.svg" />
          </a>
        </div>
        <div
          *ngIf="currentPitchCard?.linkedinLink"
          class="logo-social-link pointer">
          <a
            [href]="validateLink(currentPitchCard?.linkedinLink)"
            pTooltip="Linkedin"
            rel="noopener noreferrer"
            target="_blank"
            tooltipPosition="top">
            <img
              alt="linkedin"
              src="/assets/images/pitch-card-svg/linkedin-icon.svg" />
          </a>
        </div>
        <div
          *ngIf="currentPitchCard?.pinterestLink"
          class="logo-social-link pointer">
          <a
            [href]="validateLink(currentPitchCard?.pinterestLink)"
            pTooltip="Pinterest"
            rel="noopener noreferrer"
            target="_blank"
            tooltipPosition="top">
            <img
              alt="pinterest"
              src="/assets/images/pitch-card-svg/pinterest-icon.svg" />
          </a>
        </div>
        <div
          *ngIf="currentPitchCard?.twitterLink"
          class="logo-social-link pointer">
          <a
            [href]="validateLink(currentPitchCard?.twitterLink)"
            pTooltip="Twitter"
            rel="noopener noreferrer"
            target="_blank"
            tooltipPosition="top">
            <img
              alt="twitter"
              src="/assets/images/pitch-card-svg/twitter-icon.svg" />
          </a>
        </div>
        <div
          *ngIf="currentPitchCard?.calendarLink"
          class="logo-social-link pointer">
          <a
            [href]="validateLink(currentPitchCard?.calendarLink)"
            pTooltip="Calendar"
            rel="noopener noreferrer"
            target="_blank"
            tooltipPosition="top">
            <img alt="calendar" src="/assets/images/schedule-outline.svg" />
          </a>
        </div>
      </div>
    </div>

    <div *ngIf="currentPitchCard?.pricingModel" class="light-text mt-15">
      <div class="textarea-template">
        <div [id]="'e_description_' + uniqueId" class="editor-preview"></div>
      </div>
    </div>
  </div>
</p-dialog>

<p-dialog
  (onHide)="hideRequirements()"
  [visible]="showApplyJobDialog"
  (visibleChange)="onFlag('showApplyJobDialog', $event)"
  [dismissableMask]="true"
  [draggable]="false"
  [modal]="true"
  [resizable]="false"
  appendTo="body"
  styleClass="apply-to-job-modal">
  <div *ngIf="showApplyJobDialog" class="apply-to-job-wrapper">
    <div *ngIf="mobileMode" class="main-content">
      <div *ngIf="!userResumeCard" class="no-resume-pitchcard-mobile">
        <h2>WELCOME TO PITCH59!</h2>
        <span
          >To apply for this position you will need a FREE Resume PitchCard. If
          you don’t have one, it takes less than 10 minutes to create and will
          be yours to use when you apply for any position, forever.
          <span *ngIf="!userCommonService.userFirstName"
            >Sign up or log in to get started!</span
          >
        </span>
      </div>
      <div *ngIf="userResumeCard" class="resume-pitchcard">
        <span class="greeting">
          Hi {{ userCommonService.userFirstName || 'User' }}!
        </span>
        <span *ngIf="userResumeCard.businessStatus !== 7">
          Please confirm you’d like us to send your Resume PitchCard to apply
          for this position.
        </span>
        <span *ngIf="userResumeCard.businessStatus === 7">
          To apply for this position please complete your free Resume PitchCard.
        </span>
      </div>
    </div>
    <div #pitchCardWrapper class="pitchcard-view-section">
      <app-pitch-card
        #businessCard
        (titleClick)="handlePitchCardTitleClick($event)"
        [disabled]="true"
        [scale]="scaleFactor"
        [style]="{ margin: '1rem' }">
      </app-pitch-card>
    </div>
    <ng-template [ngIf]="mobileMode">
      <div *ngIf="!userResumeCard" class="no-resume-pitchcard-mobile">
        <div
          *ngIf="!userCommonService.userFirstName"
          class="guest-button-block">
          <button
            (click)="saveJobCardAliasLink(this.currentPitchCard); signUp()"
            class="button-simple shock-pink">
            SIGN UP (FREE)
          </button>
          <div (click)="signIn()" class="link" href="#">LOG IN</div>
        </div>
        <div *ngIf="userCommonService.userFirstName" class="user-button-block">
          <button (click)="goToCreateResume()" class="button-simple shock-pink">
            CREATE RESUME PITCHCARD
          </button>
        </div>
      </div>
      <div *ngIf="userResumeCard" class="resume-pitchcard-mobile">
        <button
          (click)="applyToTheJob()"
          *ngIf="
            userResumeCard.businessStatus === 1 ||
            userResumeCard.businessStatus === 2
          "
          [disabled]="!validToApply"
          class="apply-job-button button-simple shock-pink">
          YES, APPLY NOW
        </button>
        <p
          *ngIf="
            (userResumeCard.businessStatus === 2 ||
              userResumeCard.businessStatus === 1) &&
            !validToApply
          "
          class="special-status">
          You have already submitted your resume for this job.
        </p>
        <button
          (click)="goToDraftResume(userResumeCard.businessId)"
          *ngIf="userResumeCard.businessStatus === 7"
          class="button-simple shock-pink">
          FINISH RESUME PITCHCARD
        </button>
      </div>
    </ng-template>
    <div *ngIf="!mobileMode" class="main-content">
      <div *ngIf="!userResumeCard" class="no-resume-pitchcard">
        <h1>WELCOME TO PITCH59!</h1>
        <p>
          To apply for this position you will need a FREE Resume PitchCard. If
          you don’t have one, it takes less than 10 minutes to create and will
          be yours to use when you apply for any position, forever.
          <span *ngIf="!userCommonService.userFirstName"
            >Sign up or log in to get started!</span
          >
        </p>
        <div
          *ngIf="!userCommonService.userFirstName"
          class="guest-button-block">
          <button
            (click)="signIn()"
            class="button-simple full-width no-padding bg-darkgray lg-50">
            LOG IN
          </button>
          <button
            (click)="signUp(); saveJobCardAliasLink(this.currentPitchCard)"
            class="button-simple full-width no-padding shock-pink lg-50">
            SIGN UP
          </button>
        </div>
        <div *ngIf="userCommonService.userFirstName" class="user-button-block">
          <button (click)="goToCreateResume()" class="button-simple shock-pink">
            CREATE RESUME PITCHCARD
          </button>
        </div>
      </div>
      <div *ngIf="userResumeCard" class="resume-pitchcard">
        <app-pitch-card
          (titleClick)="handlePitchCardTitleClick($event)"
          [disabled]="true"
          [scale]="jobCardScaleFactor">
        </app-pitch-card>
        <p class="greeting">
          Hi {{ userCommonService.userFirstName || 'User' }}!
        </p>
        <p *ngIf="userResumeCard.businessStatus !== 7">
          Please confirm you’d like us to send your Resume PitchCard to apply
          for this position.
        </p>
        <p *ngIf="userResumeCard.businessStatus === 7">
          To apply for this position please complete your free Resume PitchCard.
        </p>
        <button
          (click)="applyToTheJob()"
          *ngIf="
            userResumeCard.businessStatus === 1 ||
            userResumeCard.businessStatus === 2
          "
          [disabled]="!validToApply"
          class="apply-job-button button-simple shock-pink">
          YES, APPLY NOW
        </button>
        <p
          *ngIf="
            (userResumeCard.businessStatus === 2 ||
              userResumeCard.businessStatus === 1) &&
            !validToApply
          "
          class="special-status">
          You have already submitted your resume for this job.
        </p>
        <button
          (click)="goToDraftResume(userResumeCard.businessId)"
          *ngIf="userResumeCard.businessStatus === 7"
          class="button-simple shock-pink">
          FINISH RESUME PITCHCARD
        </button>
      </div>
    </div>
  </div>
</p-dialog>

<p-dialog
  [visible]="showApplyJobDialogByLink"
  (visibleChange)="onFlag('showApplyJobDialogByLink', $event)"
  [dismissableMask]="true"
  [draggable]="false"
  [modal]="true"
  [resizable]="false"
  [style]="{ width: isMobile ? '68%' : '500px' }"
  appendTo="body">
  <div class="block my-5">
    <button
      (click)="openInNewTab(currentPitchCard.otherApplicationLink)"
      [ngClass]="{ 'lg-50': !isMobile, 'sm-35': isMobile }"
      class="button-simple w-9 sm:w-6 gradient-border-pink bg-inherit uppercase mx-auto mb-3 sm:mb-5">
      <div class="gradient-border-text">
        <p class="no-margins" translate>label_apply_now</p>
      </div>
    </button>

    <button
      (click)="signIn(); onFlag('showApplyJobDialogByLink', false)"
      [ngClass]="{ 'lg-50': !isMobile, 'sm-35': isMobile }"
      class="button-simple w-9 sm:w-6 shock-pink uppercase mx-auto"
      translate>
      label_sign_in
    </button>

    <div class="block text-center text-xs sm:text-base mt-2">
      <div class="font-light mb-2">
        Need an account?
        <span
          (click)="
            onFlag('showApplyJobDialogByLink', false);
            onFlag('showJobRequirementsDialog', false);
            signUp()
          "
          class="link font-normal green">
          SIGN UP
        </span>
      </div>
      <div
        [routerLink]="'/forgot-password'"
        class="font-bold text-black-alpha-90 link">
        Forgot password?
      </div>
    </div>
  </div>
</p-dialog>

<p-confirmDialog
  [blockScroll]="true"
  [rejectVisible]="false"
  acceptLabel="Great!"
  class="apply-job-confirmation"
  header="Congratulations!"
  key="applyJobConfirmation"></p-confirmDialog>

<p-dialog
  (onHide)="hideRequirements()"
  [visible]="showJobRequirementsDialog"
  (visibleChange)="onFlag('showJobRequirementsDialog', $event)"
  [blockScroll]="true"
  [dismissableMask]="true"
  [draggable]="false"
  [modal]="true"
  [style]="{
    width: !isMobile ? '840px' : '90%',
    maxHeight: '90%',
    padding: '0 10px 10px'
  }"
  styleClass="job-requirements-dialog"
  appendTo="body">
  <div class="mb-30">
    <h2 class="text-center no-margins">This position requires:</h2>
    <div class="text-center" style="font-size: 11px">
      (Must agree to requirements to continue with application)
    </div>
  </div>

  <div class="grid align-items-start" style="flex-wrap: nowrap">
    <p-checkbox
      [(ngModel)]="acceptPositionRequirements"
      [binary]="true"
      name="requireApplicants">
    </p-checkbox>

    <span
      [ngStyle]="{
        maxHeight: !currentPitchCard.positionRequirements
          ? (262 * scaleFactor).toFixed() + 'px'
          : !isMobile
            ? '500px'
            : '300px',
        padding: '0 10px'
      }"
      class="requirements-text w-12">
      <div [id]="'e_requirements_' + uniqueId" class="editor-preview"></div>
    </span>
  </div>

  <hr />

  <div class="p-col-7 margin-centered">
    <button
      (click)="handleAcceptPositionRequirements()"
      [disabled]="!acceptPositionRequirements"
      class="button-simple shock-pink full-width">
      CONTINUE
    </button>
  </div>
</p-dialog>
